"use strict";
/**
 * @module Control
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a Control Group request.
 */
var ControlGroup = /** @class */ (function () {
    /**
     * Create a new ControlGroup instance
     *
     * @param name   the control group name
     */
    function ControlGroup(name) {
        this.name = name;
    }
    return ControlGroup;
}());
exports.ControlGroup = ControlGroup;
/**
 * A default Control Group
 */
exports.DEFAULT = Object.freeze(new ControlGroup('default'));



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/control/control-group.js
// module id = 238
// module chunks = 1